
















































































import {Component} from 'vue-property-decorator';
import {Getter, Action} from "vuex-class";
import ReportsFilter from "@/components/Reports/ReportsFilter.vue";
import {DistributionItem} from "@/store/templates/types";
import {LongTextWings} from '@/components';
import ScrollButton from "@/components/ScrollButton.vue";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import {dateFilter} from "@/utils/date-util";
import {notifyError} from "@/utils/notify-helper";

@Component({components: {ReportsFilter,LongTextWings,ScrollButton}, filters: {dateFilter}})
export default class Reports extends BaseItemsPage<DistributionItem> {
  @Getter("reports") reports: any;

  @Action("downloadReport") actionDownloadReport: any;

  is_show_filter = true;
  currentSort = "create_date";
  currentSortOrder = "desc";

  // "id": 1,
  // "status": "FINISHED",
  // "create_date": "2022-05-26T16:16:42",
  // "finish_date": "2022-05-26T16:16:44",
  // "name": "DetailStatisticsSms_2022-05-26-16-16-42.zip"

  tableFields = [
    'id',
    'create_date',
    'finish_date',
    'name',
    'status',
  ];

  getData(): any {
    return this.reports;
  }

  downloadReport(val:number) {
    try {
      this.actionDownloadReport(val)
    } catch(error) {
      notifyError(error);
    }
  }

  statusItemColor(status:string){
    switch (status.toLowerCase()) {
      case 'finished':
        return 'background-chip-success'
      case 'failed':
        return 'background-chip-danger'
      default:
        return 'background-chip-warning'
    }
  }

}
